// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityAutomationClient } from '../../../contexts/UtilityAutomationApiContext';
import { UtilityBackend } from '../../../utils/UtilityAutomationApiClient';

export const useUnresponsiveParties = (
  backend: UtilityBackend,
): UseQueryResult<string[], string> => {
  const deadTaskClient = useUtilityAutomationClient();
  return useQuery({
    queryKey: [deadTaskClient, backend],
    queryFn: async () => {
      return deadTaskClient.unresponsiveParties(backend);
    },
  });
};
